document.addEventListener('DOMContentLoaded', () => {
  const bundleWrappers = document.querySelectorAll('.product-bundle');

  const cssEscape = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    // Intercept XMLHttpRequest calls to /cart/add as a fallback (some themes use XHR)
    if (!window.__bundleXHRPatched) {
      window.__bundleXHRPatched = true;
      const OriginalXHR = window.XMLHttpRequest;
      function BundledXHR() {
        const xhr = new OriginalXHR();
        let _method = 'GET';
        let _url = '';
        let _isCartAdd = false;
        const origOpen = xhr.open;
        xhr.open = function(method, url) {
          _method = method;
          _url = url;
          _isCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
          return origOpen.apply(xhr, arguments);
        };
        const origSend = xhr.send;
        xhr.send = function(body) {
          try {
            if (_isCartAdd) {
              const container = document.querySelector('[data-bundle-items]');
              const idInputs = container ? container.querySelectorAll('input[name="items[][id]"]') : [];
              if (idInputs && idInputs.length > 0) {
                const qtyInputs = container.querySelectorAll('input[name="items[][quantity]"]');
                const fd = new FormData();
                for (let i = 0; i < idInputs.length; i++) {
                  fd.append(`items[${i}][id]`, String(idInputs[i].value));
                  fd.append(`items[${i}][quantity]`, String(qtyInputs[i].value));
                }
                console.log('[Bundle] XHR intercepted cart/add -> forcing bundle items (FormData)', Array.from(fd.entries()));
                // Re-open to target bare endpoint without query params
                origOpen.call(xhr, 'POST', '/cart/add.js');
                return origSend.call(xhr, fd);
              }
            }
          } catch (e) {
            console.warn('[Bundle] XHR interceptor error (ignored):', e);
          }
          return origSend.apply(xhr, arguments);
        };
        return xhr;
      }
      window.XMLHttpRequest = BundledXHR;
    }
    return value.replace(/([\0-\x1F\x7F"'\\])/g, '\\$1');
  };

  bundleWrappers.forEach((bundleWrapper) => {
    const formId = bundleWrapper.dataset.productForm;
    const form = formId ? document.getElementById(formId) : null;
    const options = bundleWrapper.querySelectorAll('.product-bundle__option');
    const variantSelects = bundleWrapper.querySelectorAll('[data-bundle-variant-select]');
    let hiddenPropertyInput = bundleWrapper.querySelector('[data-bundle-property]');
    let hiddenDiscountInput = bundleWrapper.querySelector('[data-bundle-discount]');
    let bundleItemsContainer = bundleWrapper.querySelector('[data-bundle-items]');
    const quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    const variantIdInput = form ? form.querySelector('input[name="id"]') : null;
    const baseIdFields = form ? Array.from(form.querySelectorAll('[name="id"]')) : [];
    const baseQuantityFields = form ? Array.from(form.querySelectorAll('input[name="quantity"]')) : [];
    let modifiedRadios = []; // Track radio inputs that were modified
    let isSyncingFromBundle = false;
    let isSyncingFromForm = false;
    const atcAddText = bundleWrapper.dataset.atcAddText || '';
    const atcSoldOutText = bundleWrapper.dataset.atcSoldOutText || '';
    const addToCartButton = form ? form.querySelector('button[type="submit"], [name="add"]') : null;
    const atcTextSpan = addToCartButton ? addToCartButton.querySelector('.hdt-btn-atc_text') : null;

    const removeFieldName = (field) => {
      if (!field) return;
      if (!field.hasAttribute('data-original-name') && field.name) {
        field.setAttribute('data-original-name', field.name);
      }
      field.removeAttribute('name');
    };

    const restoreFieldName = (field) => {
      if (!field) return;
      const originalName = field.getAttribute('data-original-name');
      if (originalName) {
        field.setAttribute('name', originalName);
        field.removeAttribute('data-original-name');
      }
    };

    const removeFormAttribute = (field) => {
      if (!field) return;
      if (!field.hasAttribute('data-original-form') && field.getAttribute('form')) {
        field.setAttribute('data-original-form', field.getAttribute('form'));
      }
      field.removeAttribute('form');
    };

    const restoreFormAttribute = (field) => {
      if (!field) return;
      const originalForm = field.getAttribute('data-original-form');
      if (originalForm) {
        field.setAttribute('form', originalForm);
        field.removeAttribute('data-original-form');
      }
    };

    const disableBaseIdFields = () => {
      baseIdFields.forEach((field) => {
        removeFieldName(field);
        field.setAttribute('disabled', 'disabled');
      });
      // Also disable all radio inputs that target this form (including those already processed)
      const allRadios = document.querySelectorAll(`input[type="radio"][form="${formId}"], input[type="radio"][data-original-form="${formId}"]`);
      allRadios.forEach((radio) => {
        removeFormAttribute(radio);
        removeFieldName(radio); // CRITICAL: Remove name attribute to prevent submission
        radio.setAttribute('disabled', 'disabled');
        if (!modifiedRadios.includes(radio)) {
          modifiedRadios.push(radio); // Track for restoration
        }
      });
    };

    const restoreBaseIdFields = () => {
      baseIdFields.forEach((field) => {
        restoreFieldName(field);
        field.removeAttribute('disabled');
      });
      // Also restore radio inputs
      modifiedRadios.forEach((radio) => {
        restoreFormAttribute(radio);
        restoreFieldName(radio); // Restore name attribute
        radio.removeAttribute('disabled');
      });
      modifiedRadios = []; // Clear the array
    };

    const disableBaseQuantityFields = () => {
      baseQuantityFields.forEach((field) => {
        removeFieldName(field);
        field.setAttribute('disabled', 'disabled');
        if (field === quantityInput) {
          field.value = '0';
        }
      });
    };

    const restoreBaseQuantityFields = () => {
      baseQuantityFields.forEach((field) => {
        restoreFieldName(field);
        field.removeAttribute('disabled');
      });
    };

    const getProductVariants = () => {
      const productJsonScript = document.querySelector(`script[data-product-json]`);
      if (productJsonScript) {
        try {
          return JSON.parse(productJsonScript.textContent).variants || [];
        } catch (e) {
          console.error('[Bundle] Failed to parse product JSON:', e);
        }
      }
      if (window.productVariants) {
        return window.productVariants;
      }
      return [];
    };

    const findVariantByOptions = (option1, option2, option3) => {
      const variants = getProductVariants();
      console.log('[Bundle] Looking for variant with options:', { option1, option2, option3 });
      console.log('[Bundle] Available variants:', variants);

      return variants.find(variant => {
        const match = 
          (option1 === null || variant.option1 === option1) &&
          (option2 === null || variant.option2 === option2) &&
          (option3 === null || variant.option3 === option3);
        return match && variant.available;
      });
    };

    const updateVariantId = () => {
      if (!variantIdInput) return;

      const option1 = getCurrentFormOptionValue(null, 0);
      const option2 = getCurrentFormOptionValue(null, 1);
      const option3 = getCurrentFormOptionValue(null, 2);

      const variant = findVariantByOptions(option1, option2, option3);

      if (variant && variant.id) {
        console.log('[Bundle] Found matching variant:', variant.id, variant.title);
        variantIdInput.value = variant.id;
        if (variantIdInput.hasAttribute('disabled')) {
          variantIdInput.removeAttribute('disabled');
        }
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        console.warn('[Bundle] No matching variant found for options:', { option1, option2, option3 });
      }
    };

    const ensureBundleItemsContainer = () => {
      if (!form) return null;
      // Find the main product form by its ID
      const mainFormId = bundleWrapper.dataset.productForm;
      const mainForm = mainFormId ? document.getElementById(mainFormId) : null;
      
      if (!mainForm) return null;
      
      if (bundleItemsContainer && bundleItemsContainer.isConnected && bundleItemsContainer.parentElement === mainForm) {
        return bundleItemsContainer;
      }
      bundleItemsContainer = mainForm.querySelector('[data-bundle-items]');
      if (!bundleItemsContainer) {
        bundleItemsContainer = document.createElement('div');
        bundleItemsContainer.setAttribute('data-bundle-items', '');
        bundleItemsContainer.style.display = 'none';
        mainForm.appendChild(bundleItemsContainer);
      }
      return bundleItemsContainer;
    };

    const clearBundleItemInputs = () => {
      const container = ensureBundleItemsContainer();
      if (!container) return;
      container.innerHTML = '';
    };

    const appendBundleItemInput = (variantId, quantity) => {
      if (!variantId || !quantity) return;
      const container = ensureBundleItemsContainer();
      if (!container) {
        console.error('[Bundle] Cannot append items - container not found!');
        return;
      }

      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'items[][id]';
      idInput.value = variantId;
      container.appendChild(idInput);

      const quantityInputElement = document.createElement('input');
      quantityInputElement.type = 'hidden';
      quantityInputElement.name = 'items[][quantity]';
      quantityInputElement.value = quantity;
      container.appendChild(quantityInputElement);
      
      console.log(`[Bundle] Created hidden input: items[][id]=${variantId}, items[][quantity]=${quantity}`);
      console.log('[Bundle] Container HTML:', container.innerHTML);
      console.log('[Bundle] Container parent element:', container.parentElement);
      console.log('[Bundle] Container parent tagName:', container.parentElement?.tagName);
      console.log('[Bundle] Container parent id:', container.parentElement?.id);
    };

    const getVariantIdForSelect = (select) => {
      const optionIndex = getOptionIndex(select);
      if (optionIndex == null) return null;
      
      // Build option values array, using select value for the specific option
      const optionValues = [null, null, null];
      optionValues[optionIndex] = select.value;
      
      // For a single-option product (like size-only), this is enough
      const variant = findVariantByOptions(optionValues[0], optionValues[1], optionValues[2]);
      return variant ? variant.id : null;
    };

    const syncBundleItemsToForm = (optionElement) => {
      if (!form || !optionElement) return;
      const selectsForOption = optionElement.querySelectorAll('[data-bundle-variant-select]');
      clearBundleItemInputs();

      if (!selectsForOption.length) {
        // No bundle selects - re-enable base inputs for single product mode
        restoreBaseIdFields();
        restoreBaseQuantityFields();
        const configuredQuantity = optionElement.dataset.quantity || bundleWrapper.dataset.initialQuantity || '1';
        updateQuantity(configuredQuantity);
        return;
      }

      const variantSequence = [];
      selectsForOption.forEach((select, idx) => {
        if (select.disabled) return;
        const variantId = getVariantIdForSelect(select);
        console.log(`[Bundle] Select ${idx + 1}: size=${select.value} → variantId=${variantId}`);
        if (variantId) {
          variantSequence.push(variantId);
        } else {
          console.warn('[Bundle] Unable to resolve variant for select value:', select.value);
        }
      });

      if (!variantSequence.length) {
        if (typeof updateAddToCartButtonState === 'function') {
          updateAddToCartButtonState(false);
        }
        return;
      }

      const variantCounts = new Map();
      variantSequence.forEach((variantId) => {
        const currentCount = variantCounts.get(variantId) || 0;
        variantCounts.set(variantId, currentCount + 1);
      });

      // If only 1 pair (single variant or all same), use base form inputs
      if (variantSequence.length === 1) {
        restoreBaseIdFields();
        restoreBaseQuantityFields();
        if (variantIdInput) {
          variantIdInput.value = variantSequence[0];
        }
        updateQuantity(1);
        console.log('[Bundle] Single pair mode - using base inputs');
        if (typeof updateAddToCartButtonState === 'function') {
          updateAddToCartButtonState(true);
        }
        return;
      }

      // Multiple pairs - disable base inputs and use items[] array for all variants
      console.log('[Bundle] Multi-pair mode - disabling base inputs, using items[] for all variants');
      
      disableBaseIdFields();
      disableBaseQuantityFields();

      // Add ALL variants (including primary) as items[]
      console.log('[Bundle] Adding bundle items to cart:', Array.from(variantCounts.entries()).map(([id, qty]) => `${id} x${qty}`).join(', '));
      variantCounts.forEach((count, variantId) => {
        appendBundleItemInput(variantId, count);
      });
      if (typeof updateAddToCartButtonState === 'function') {
        updateAddToCartButtonState(true);
      }
    };

    const getOptionIndex = (select) => {
      const index = parseInt(select.dataset.optionIndex, 10);
      return Number.isNaN(index) ? null : index;
    };

    const getOptionPosition = (select) => {
      const position = parseInt(select.dataset.optionPosition, 10);
      return Number.isNaN(position) ? null : position;
    };

    const getCurrentFormOptionValue = (optionName, optionIndex) => {
      if (!optionName && optionIndex == null) return null;
      let value = null;
      if (optionName) {
        const escapedName = cssEscape(optionName);
        const checkedRadio = form.querySelector(`input[is-value][type="radio"][name="${escapedName}"]:checked`);
        if (checkedRadio) {
          value = checkedRadio.value;
        }
      }
      if (value == null && optionIndex != null) {
        const hiddenInput = form.querySelector(`input[is-value][name="option${optionIndex + 1}"]`);
        if (hiddenInput) {
          value = hiddenInput.value;
        }
      }
      return value;
    };

    const setFormOptionValue = (optionName, optionIndex, value) => {
      if (!value) return null;
      console.log('[Bundle] Setting form option:', { optionName, optionIndex, value });
      const escapedName = optionName ? cssEscape(optionName) : null;
      let appliedValue = value;
      if (escapedName) {
        const radioInputs = form.querySelectorAll(`input[is-value][type="radio"][name="${escapedName}"]`);
        console.log('[Bundle] Found radio inputs:', radioInputs.length);
        let targetRadio = null;
        radioInputs.forEach((radio) => {
          if (!targetRadio && radio.value === value && !radio.disabled && !radio.classList.contains('is-disabled')) {
            targetRadio = radio;
          }
        });
        if (!targetRadio && radioInputs.length) {
          targetRadio = Array.from(radioInputs).find((radio) => !radio.disabled && !radio.classList.contains('is-disabled')) || radioInputs[0];
          appliedValue = targetRadio ? targetRadio.value : value;
        }
        if (targetRadio && !targetRadio.checked) {
          console.log('[Bundle] Checking radio:', targetRadio.value);
          targetRadio.checked = true;
          targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
          targetRadio.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      if (optionIndex != null) {
        const hiddenInput = form.querySelector(`input[is-value][name="option${optionIndex + 1}"]`);
        if (hiddenInput && hiddenInput.value !== appliedValue) {
          console.log('[Bundle] Updating hidden input:', `option${optionIndex + 1}`, appliedValue);
          hiddenInput.value = appliedValue;
          hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
          hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      return appliedValue;
    };

    const syncBundleSelectFromForm = (optionElement) => {
      if (isSyncingFromBundle || !optionElement) return;
      
      // Don't sync in multi-pair mode - bundle selects should be independent
      const selectsForOption = optionElement.querySelectorAll('[data-bundle-variant-select]');
      const activeSelects = Array.from(selectsForOption).filter(s => !s.disabled);
      if (activeSelects.length > 1) {
        console.log('[Bundle] Skipping form sync - multi-pair mode');
        return; // Multi-pair mode - don't sync from form
      }
      
      const primarySelect = optionElement.querySelector('[data-bundle-primary="true"][data-bundle-variant-select]');
      if (!primarySelect) return;
      const optionIndex = getOptionIndex(primarySelect);
      const optionName = primarySelect.dataset.optionName;
      const currentValue = getCurrentFormOptionValue(optionName, optionIndex);
      if (currentValue != null && primarySelect.value !== currentValue) {
        isSyncingFromForm = true;
        primarySelect.value = currentValue;
        syncBundleItemsToForm(optionElement);
        isSyncingFromForm = false;
      }
    };

    const syncBundleSelectToForm = (select) => {
      if (isSyncingFromForm || !select.dataset.bundlePrimary) return;
      const optionElement = select.closest('.product-bundle__option');
      if (!optionElement || !optionElement.classList.contains('is-active')) return;
      console.log('[Bundle] Syncing bundle select to form:', select.value);
      const optionIndex = getOptionIndex(select);
      const optionName = select.dataset.optionName;
      const desiredValue = select.value;
      isSyncingFromBundle = true;
      const appliedValue = setFormOptionValue(optionName, optionIndex, desiredValue);
      isSyncingFromBundle = false;
      if (appliedValue != null && appliedValue !== desiredValue) {
        isSyncingFromForm = true;
        select.value = appliedValue;
        isSyncingFromForm = false;
      }
      
      // Update variant ID based on selected options
      updateVariantId();
      
      // Trigger variant picker update
      const variantPicker = form.querySelector('hdt-variant-picker');
      if (variantPicker) {
        console.log('[Bundle] Triggering variant picker update');
        variantPicker.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Force form to recalculate variant
      const formChangeEvent = new Event('change', { bubbles: true });
      form.dispatchEvent(formChangeEvent);
    };

    const handleVariantSelectChange = (select) => {
      const isPrimary = select.dataset.bundlePrimary === 'true';
      if (!isSyncingFromForm && !isSyncingFromBundle) {
        const logLabel = isPrimary ? 'Primary' : 'Secondary';
        console.log(`[Bundle] ${logLabel} bundle select changed:`, select.value);
      }

      if (isPrimary) {
        syncBundleSelectToForm(select);
      } else {
        const eventDetail = { select, value: select.value };
        bundleWrapper.dispatchEvent(new CustomEvent('bundle:secondary-select-change', {
          bubbles: true,
          detail: eventDetail
        }));
      }

      const currentActiveOption = bundleWrapper.querySelector('.product-bundle__option.is-active');
      if (currentActiveOption) {
        syncBundleItemsToForm(currentActiveOption);
      }
    };

    const updateQuantity = (quantity) => {
      if (!quantityInput) return;
      const min = parseInt(quantityInput.getAttribute('min') || '1', 10);
      const max = parseInt(quantityInput.getAttribute('max') || quantityInput.value, 10);
      let targetQty = parseInt(quantity, 10) || min;
      targetQty = Math.max(targetQty, min);
      if (!Number.isNaN(max) && max > 0) {
        targetQty = Math.min(targetQty, max);
      }
      if (Number(quantityInput.value) !== targetQty) {
        quantityInput.value = targetQty;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const updateActiveState = (selectedOption) => {
      options.forEach((option) => option.classList.remove('is-active'));
      selectedOption.classList.add('is-active');
    };

    const updateHiddenFields = (option) => {
      const bundleTitle = option.dataset.bundleTitle || '';
      const propertyLabel = option.dataset.propertyLabel || 'Bundle';
      const discountCode = option.dataset.discountCode || '';

      if (!hiddenPropertyInput) {
        hiddenPropertyInput = bundleWrapper.querySelector('[data-bundle-property]');
      }

      if (!hiddenPropertyInput) {
        hiddenPropertyInput = document.createElement('input');
        hiddenPropertyInput.type = 'hidden';
        hiddenPropertyInput.setAttribute('data-bundle-property', '');
        bundleWrapper.appendChild(hiddenPropertyInput);
      }

      const propertyKeyMatch = hiddenPropertyInput.name && hiddenPropertyInput.name.match(/properties\[(.*)\]/);
      if (propertyKeyMatch || !hiddenPropertyInput.name) {
        hiddenPropertyInput.name = `properties[${propertyLabel}]`;
      }
      hiddenPropertyInput.value = bundleTitle;

      if (!hiddenDiscountInput) {
        hiddenDiscountInput = bundleWrapper.querySelector('[data-bundle-discount]');
      }

      if (!hiddenDiscountInput) {
        hiddenDiscountInput = document.createElement('input');
        hiddenDiscountInput.type = 'hidden';
        hiddenDiscountInput.name = 'properties[Bundle Discount Code]';
        hiddenDiscountInput.setAttribute('data-bundle-discount', '');
        bundleWrapper.appendChild(hiddenDiscountInput);
      }

      hiddenDiscountInput.value = discountCode;
    };

    const updateVariantSelectAvailability = (selectedOption) => {
      options.forEach((option) => {
        const selects = option.querySelectorAll('[data-bundle-variant-select]');
        selects.forEach((select) => {
          if (option === selectedOption) {
            select.removeAttribute('disabled');
          } else {
            select.setAttribute('disabled', 'disabled');
          }
        });
      });
    };

    const updateAddToCartButtonState = (isAvailable) => {
      if (!addToCartButton || !atcTextSpan) return;

      if (isAvailable) {
        addToCartButton.removeAttribute('disabled');
        if (atcAddText) {
          atcTextSpan.textContent = atcAddText;
        }
      } else {
        addToCartButton.setAttribute('disabled', 'true');
        if (atcSoldOutText) {
          atcTextSpan.textContent = atcSoldOutText;
        }
      }
    };

    const handleSelection = (option) => {
      console.log('[Bundle] Handling bundle selection:', option.dataset.bundleTitle);
      updateHiddenFields(option);
      updateActiveState(option);
      updateVariantSelectAvailability(option);
      syncBundleSelectFromForm(option);
      syncBundleItemsToForm(option);
    };

    options.forEach((option) => {
      const radio = option.querySelector('.product-bundle__radio');
      radio?.addEventListener('change', () => handleSelection(option));
      option.addEventListener('click', (event) => {
        if (event.target.tagName !== 'SELECT' && event.target.tagName !== 'OPTION') {
          const wasChecked = radio.checked;
          if (!wasChecked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });

    const activeOption = bundleWrapper.querySelector('.product-bundle__option.is-active') || options[0];
    if (activeOption) {
      handleSelection(activeOption);
      syncBundleSelectFromForm(activeOption);
    }

    // Ensure selects remain interactive when quantity inputs change externally
    variantSelects.forEach((select) => {
      select.addEventListener('click', (event) => {
        event.stopPropagation();
      });
      select.addEventListener('change', () => {
        handleVariantSelectChange(select);
      });
    });

    form.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || !target.hasAttribute('is-value')) return;
      const currentActiveOption = bundleWrapper.querySelector('.product-bundle__option.is-active');
      if (!currentActiveOption) return;
      syncBundleSelectFromForm(currentActiveOption);
      syncBundleItemsToForm(currentActiveOption);
    });

    // Intercept Add to Cart button click (theme bypasses form submit event)
    if (addToCartButton) {
      addToCartButton.addEventListener('click', (event) => {
        const container = form.querySelector('[data-bundle-items]');
        const bundleItemInputs = container ? container.querySelectorAll('input[name="items[][id]"]') : [];
        
        console.log('[Bundle] ADD TO CART BUTTON CLICKED');
        console.log(`[Bundle] Found ${bundleItemInputs.length} bundle item inputs`);
        
        // If we have bundle items (multi-pair mode), intercept and submit via AJAX
        if (bundleItemInputs.length > 0) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          console.log('[Bundle] Intercepting - submitting bundle items via AJAX');
          
          // Build the items array from bundle inputs
          const items = [];
          const idInputs = Array.from(bundleItemInputs);
          const qtyInputs = Array.from(container.querySelectorAll('input[name="items[][quantity]"]'));
          
          for (let i = 0; i < idInputs.length; i++) {
            items.push({
              id: idInputs[i].value,
              quantity: parseInt(qtyInputs[i].value)
            });
            console.log(`[Bundle] Item ${i + 1}: ID=${idInputs[i].value}, Qty=${qtyInputs[i].value}`);
          }
          
          // Submit to Shopify cart API with FormData (more reliable across themes)
          const fd = new FormData();
          items.forEach((it, idx) => {
            fd.append(`items[${idx}][id]`, String(it.id));
            fd.append(`items[${idx}][quantity]`, String(it.quantity));
          });
          console.log('[Bundle] Submitting FormData to /cart/add.js:', Array.from(fd.entries()));

          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: fd
          })
          .then(async (response) => {
            const text = await response.text();
            if (!response.ok) {
              console.error('[Bundle] Cart add HTTP error', response.status, text);
              throw new Error('HTTP ' + response.status);
            }
            try { return JSON.parse(text); } catch { return text; }
          })
          .then(data => {
            console.log('[Bundle] Cart add SUCCESS:', data);
            window.location.reload();
          })
          .catch(error => {
            console.error('[Bundle] Cart add error:', error);
            alert('Error adding items to cart. Please try again.');
          });
          
          return false;
        }
        
        console.log('[Bundle] No bundle items - allowing normal button action');
      }, true); // Use capture phase to run BEFORE theme's handler
    } else {
      console.warn('[Bundle] Could not find Add to Cart button!');
    }

    // Global capture listener: intercept clicks that target this product's buy buttons or form
    const mainFormId = form.id;
    const isTargetingThisProduct = (target) => {
      if (!target) return false;
      // Click inside the main form
      if (target.closest && target.closest(`#${CSS && CSS.escape ? CSS.escape(mainFormId) : mainFormId}`)) return true;
      // Click inside a buy-buttons element that points to this form
      const buyButtons = target.closest && target.closest('hdt-buy-buttons');
      if (buyButtons && buyButtons.getAttribute('form') === mainFormId) return true;
      return false;
    };

    const tryAjaxSubmitBundle = (eventSource) => {
      // Ensure hidden inputs are up to date at the moment of click
      const currentActiveOption = bundleWrapper.querySelector('.product-bundle__option.is-active') || options[0];
      if (currentActiveOption) {
        console.log('[Bundle] Forcing sync before submit');
        handleSelection(currentActiveOption);
        syncBundleItemsToForm(currentActiveOption);
      }

      const container = form.querySelector('[data-bundle-items]');
      const idInputs = container ? container.querySelectorAll('input[name="items[][id]"]') : [];
      if (!idInputs || idInputs.length === 0) return false;

      const qtyInputs = container.querySelectorAll('input[name="items[][quantity]"]');
      const items = [];
      for (let i = 0; i < idInputs.length; i++) {
        items.push({ id: idInputs[i].value, quantity: parseInt(qtyInputs[i].value) });
      }
      console.log(`[Bundle] Intercepted ${eventSource} -> submitting ${items.length} bundle items via AJAX`, items);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(r => r.json())
      .then(data => {
        console.log('[Bundle] Cart add SUCCESS (global capture):', data);
        window.location.reload();
      })
      .catch(err => {
        console.error('[Bundle] Cart add error (global capture):', err);
        alert('Error adding bundle to cart. Please try again.');
      });
      return true;
    };

    const onGlobalClickCapture = (e) => {
      const target = e.target;
      if (!isTargetingThisProduct(target)) return;
      // Only act if bundle inputs exist (multi-pair)
      const container = form.querySelector('[data-bundle-items]');
      const hasBundle = container && container.querySelector('input[name="items[][id]"]');
      if (!hasBundle) return;
      // Stop theme handlers and submit our bundle payload instead
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      console.log('[Bundle] Global click capture: intercepting add-to-cart for bundle');
      tryAjaxSubmitBundle('click');
    };

    document.addEventListener('click', onGlobalClickCapture, true);
    
    // Clean up listener if needed when SPA navigates (defensive)
    window.addEventListener('unload', () => {
      document.removeEventListener('click', onGlobalClickCapture, true);
    });

    // Intercept fetch calls to /cart/add to enforce bundle items
    if (!window.__bundleFetchPatched) {
      window.__bundleFetchPatched = true;
      const originalFetch = window.fetch.bind(window);
      window.fetch = async (input, init = {}) => {
        try {
          const url = typeof input === 'string' ? input : (input && input.url) || '';
          const isCartAdd = url.includes('/cart/add');

          // Allow other widgets (Mix & Match) to opt out via X-MixMatch header
          let skipBundle = false;
          if (init && init.headers) {
            const headers = init.headers;
            if (headers instanceof Headers) {
              skipBundle = headers.get('X-MixMatch') === 'true';
            } else if (typeof headers === 'object') {
              skipBundle =
                headers['X-MixMatch'] === 'true' ||
                headers['x-mixmatch'] === 'true';
            }
          }

          if (isCartAdd && !skipBundle) {
            const container = form.querySelector('[data-bundle-items]');
            const idInputs = container ? container.querySelectorAll('input[name="items[][id]"]') : [];
            if (idInputs && idInputs.length > 0) {
              // Build items from bundle
              const qtyInputs = container.querySelectorAll('input[name="items[][quantity]"]');
              const items = [];
              for (let i = 0; i < idInputs.length; i++) {
                items.push({ id: idInputs[i].value, quantity: parseInt(qtyInputs[i].value) });
              }
              console.log('[Bundle] fetch() intercepted cart/add -> forcing bundle items (FormData)', items);
              const fd = new FormData();
              items.forEach((it, idx) => {
                fd.append(`items[${idx}][id]`, String(it.id));
                fd.append(`items[${idx}][quantity]`, String(it.quantity));
              });
              console.log('[Bundle] Interceptor FormData entries:', Array.from(fd.entries()));
              return originalFetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd });
            }
          }
        } catch (e) {
          console.warn('[Bundle] fetch interceptor error (ignored):', e);
        }
        return originalFetch(input, init);
      };
    }
  });
});
